import { IS_HYBRIDGE } from "src/modules/smile/shared/consts";

export const SMILE_PLUS_PRICE_MONTHLY = IS_HYBRIDGE ? 60 : 24;
export const SMILE_PLUS_PRICE_YEARLY = IS_HYBRIDGE ? 0 : 228;
